// VNEC v9 — pages/du-an.js
// Quản lý dự án — v9 schema (ma_da, ten_da). FE hiển thị ma_du_an/ten_du_an
// qua generated columns nhưng WRITE phải dùng ma_da/ten_da.
import { supabase, getCurrentUser } from '../lib/supabase.js';

// Canonical trang_thai values (v9 schema default 'active')
const STATUSES = [
  { value: 'active',     label: 'Đang thực hiện' },
  { value: 'completed',  label: 'Đã hoàn thành' },
  { value: 'paused',     label: 'Tạm dừng' },
  { value: 'cancelled',  label: 'Đã hủy' }
];
const ST_LABEL = Object.fromEntries(STATUSES.map(s => [s.value, s.label]));

let _state = { rows: [], user: null };

export function renderDuAn() {
  window.__pageInit = initDuAn;
  return `
    <div class="crud-wrap">
      <div class="page-hd">
        <h2>Quản lý Dự án</h2>
        <div>
          <button class="btn btn-primary btn-sm" id="da-new">+ Tạo dự án</button>
          <button class="btn btn-ghost btn-sm" id="da-refresh">⟳</button>
        </div>
      </div>
      <div class="crud-filters">
        <input type="text" class="inp" id="f-search" placeholder="Tìm mã, tên, chủ đầu tư…" style="min-width:280px">
        <select class="inp" id="f-status"><option value="">Tất cả trạng thái</option>${STATUSES.map(s => `<option value="${s.value}">${s.label}</option>`).join('')}</select>
      </div>
      <div id="da-table" class="crud-table-wrap"><div class="loading">Đang tải…</div></div>
      <div id="da-modal" class="modal-overlay" style="display:none"></div>
    </div>`;
}

async function initDuAn() {
  _state.user = await getCurrentUser();
  document.getElementById('da-new').addEventListener('click', () => openForm(null));
  document.getElementById('da-refresh').addEventListener('click', load);
  document.getElementById('f-search').addEventListener('input', renderTable);
  document.getElementById('f-status').addEventListener('change', renderTable);
  await load();
}

async function load() {
  try {
    const { data, error } = await supabase.from('du_an')
      .select('id,ma_da,ten_da,chu_dau_tu,gia_tri_hd,trang_thai,ghi_chu')
      .is('deleted_at', null).order('ma_da').limit(1000);
    if (error) throw error;
    _state.rows = data || [];
    renderTable();
  } catch (e) {
    document.getElementById('da-table').innerHTML = `<div class="error-box">Lỗi: ${e.message}</div>`;
  }
}

function renderTable() {
  const q = (document.getElementById('f-search').value || '').toLowerCase();
  const st = document.getElementById('f-status').value;
  const rows = _state.rows.filter(r =>
    (!st || r.trang_thai === st) &&
    (!q || (r.ma_da || '').toLowerCase().includes(q) || (r.ten_da || '').toLowerCase().includes(q) || (r.chu_dau_tu || '').toLowerCase().includes(q))
  );
  if (!rows.length) { document.getElementById('da-table').innerHTML = '<div class="empty">Không có dự án</div>'; return; }

  let html = '<table class="tbl"><thead><tr><th style="width:120px">Mã DA</th><th>Tên dự án</th><th>Chủ đầu tư</th><th class="num">Giá trị HĐ</th><th class="c" style="width:130px">Trạng thái</th><th class="c" style="width:140px">Thao tác</th></tr></thead><tbody>';
  rows.forEach(r => {
    html += `<tr>
      <td><b>${escH(r.ma_da)}</b></td>
      <td>${escH(r.ten_da || '')}</td>
      <td>${escH(r.chu_dau_tu || '')}</td>
      <td class="num">${new Intl.NumberFormat('vi-VN').format(r.gia_tri_hd || 0)}</td>
      <td class="c">${daBadge(r.trang_thai)}</td>
      <td class="c">
        <button class="btn-mini view" data-act="edit" data-key="${escH(r.id)}">Sửa</button>
        <button class="btn-mini reject" data-act="delete" data-key="${escH(r.id)}">Xóa</button>
      </td>
    </tr>`;
  });
  html += '</tbody></table>';
  document.getElementById('da-table').innerHTML = html;

  document.querySelectorAll('#da-table button[data-act]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.dataset.act === 'edit') openForm(btn.dataset.key);
      else if (btn.dataset.act === 'delete') doDelete(btn.dataset.key);
    });
  });
}

function openForm(id) {
  const modal = document.getElementById('da-modal');
  modal.style.display = 'flex';
  const r = id ? _state.rows.find(x => x.id === id) : {};
  modal.innerHTML = `
    <div class="modal-box">
      <div class="m-hd"><div class="m-title">${id ? 'Sửa dự án: ' + escH(r.ma_da) : 'Tạo dự án mới'}</div><button class="m-close" id="mc">×</button></div>
      <div class="m-body">
        <form id="da-form">
          <label class="field"><span>Mã dự án *</span><input name="ma_da" class="inp" required ${id?'readonly':''} value="${escH(r.ma_da || '')}" placeholder="VD: DA-2026-001"></label>
          <label class="field"><span>Tên dự án *</span><input name="ten_da" class="inp" required value="${escH(r.ten_da || '')}"></label>
          <label class="field"><span>Chủ đầu tư</span><input name="chu_dau_tu" class="inp" value="${escH(r.chu_dau_tu || '')}"></label>
          <label class="field"><span>Giá trị HĐ (tham khảo)</span><input name="gia_tri_hd" class="inp" type="number" min="0" value="${r.gia_tri_hd || 0}"></label>
          <label class="field"><span>Ghi chú</span><textarea name="ghi_chu" class="inp" rows="2">${escH(r.ghi_chu || '')}</textarea></label>
          <label class="field"><span>Trạng thái</span><select name="trang_thai" class="inp">${STATUSES.map(s => `<option value="${s.value}"${(r.trang_thai || 'active') === s.value ? ' selected' : ''}>${s.label}</option>`).join('')}</select></label>
          <div class="modal-actions"><button type="button" class="btn btn-ghost" id="cancel">Hủy</button><button type="submit" class="btn btn-primary">Lưu</button></div>
        </form>
      </div>
    </div>`;
  document.getElementById('mc').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('cancel').addEventListener('click', () => modal.style.display = 'none');
  document.getElementById('da-form').addEventListener('submit', async e => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const payload = {
      ma_da: fd.get('ma_da').trim(),
      ten_da: fd.get('ten_da').trim(),
      chu_dau_tu: fd.get('chu_dau_tu').trim() || null,
      gia_tri_hd: Number(fd.get('gia_tri_hd') || 0),
      ghi_chu: fd.get('ghi_chu').trim() || null,
      trang_thai: fd.get('trang_thai')
    };
    try {
      if (id) {
        const { error } = await supabase.from('du_an').update(payload).eq('id', id);
        if (error) throw error;
        toast('Đã cập nhật', 'ok');
      } else {
        const { error } = await supabase.from('du_an').insert(payload);
        if (error) throw error;
        toast('Đã tạo: ' + payload.ma_da, 'ok');
        // v3: Auto-prompt cấp quyền cho data_entry sau khi tạo dự án mới
        setTimeout(() => promptGrantAccess(payload.ma_da), 500);
      }
      modal.style.display = 'none';
      load();
    } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
  });
}

// v3: Prompt admin cấp quyền cho các data_entry users vào dự án vừa tạo
async function promptGrantAccess(maDa) {
  try {
    const { data: users, error } = await supabase.rpc('admin_list_users');
    if (error || !users) return;
    const candidates = users.filter(u => u.role === 'data_entry' || u.role === 'viewer');
    if (!candidates.length) return;

    const modal = document.createElement('div');
    modal.className = 'modal-overlay';
    modal.style.display = 'flex';
    modal.innerHTML = `
      <div class="modal-box" style="max-width:520px">
        <div class="m-hd"><div class="m-title">🔐 Cấp quyền dự án ${maDa}</div><button class="m-close" id="pga-close">×</button></div>
        <div class="m-body">
          <p style="margin-bottom:14px;color:#666;font-size:13px">Chọn user cần cấp quyền truy cập dự án <b>${maDa}</b>:</p>
          <div style="max-height:300px;overflow-y:auto;border:1px solid #EEE;border-radius:6px">
            ${candidates.map(u => `
              <label style="display:flex;align-items:center;gap:10px;padding:10px 14px;border-bottom:1px solid #F4F4FB;cursor:pointer">
                <input type="checkbox" class="pga-cb" value="${u.id}" style="width:18px;height:18px">
                <div style="flex:1">
                  <div style="font-weight:700;color:#000066;font-size:12px">${u.full_name || u.email}</div>
                  <div style="font-size:10px;color:#888">${u.email} · ${u.role}</div>
                </div>
              </label>
            `).join('')}
          </div>
          <div class="form-actions" style="margin-top:16px">
            <button type="button" class="btn btn-ghost" id="pga-skip">Bỏ qua</button>
            <button type="button" class="btn btn-primary" id="pga-grant">Cấp quyền</button>
          </div>
        </div>
      </div>`;
    document.body.appendChild(modal);

    const close = () => modal.remove();
    modal.querySelector('#pga-close').addEventListener('click', close);
    modal.querySelector('#pga-skip').addEventListener('click', close);
    modal.querySelector('#pga-grant').addEventListener('click', async () => {
      const selected = Array.from(modal.querySelectorAll('.pga-cb:checked')).map(cb => cb.value);
      if (!selected.length) { close(); return; }
      try {
        await supabase.rpc('admin_bulk_grant_project', { p_ma_da: maDa, p_user_ids: selected });
        toast(`Đã cấp quyền ${maDa} cho ${selected.length} user`, 'ok');
      } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
      close();
    });
  } catch (e) { /* silent */ }
}

async function doDelete(id) {
  const row = _state.rows.find(r => r.id === id);
  if (!row) return;
  if (!confirm(`Xóa dự án ${row.ma_da}?\n\nLưu ý: nếu có HĐ/CP gắn với dự án này, xóa sẽ fail.`)) return;
  try {
    // Soft delete
    const { error } = await supabase.from('du_an').update({ deleted_at: new Date().toISOString() }).eq('id', id);
    if (error) throw error;
    toast('Đã xóa', 'ok');
    load();
  } catch (e) { toast('Lỗi: ' + e.message, 'err'); }
}

function daBadge(st) {
  const cls = { active:'green', completed:'gray', paused:'orange', cancelled:'red' };
  return `<span class="dot-badge dot-${cls[st] || 'gray'}">${ST_LABEL[st] || st}</span>`;
}
function escH(s) { return String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
function toast(msg, type='ok') {
  const c = document.getElementById('toast-container'); if (!c) { alert(msg); return; }
  const el = document.createElement('div'); el.className = 'toast toast-' + type; el.textContent = msg;
  c.appendChild(el); setTimeout(() => el.remove(), 3500);
}
